






import {Vue, Component, Prop} from 'vue-property-decorator';

@Component({
  name: 'Title',
  props: {
    tag: {
      type: String,
      default: 'h2',
    },
    text: {
      type: String,
      required: true,
      default: '',
    },
    position: {
      type: String,
      required: false,
      default: 'center',
    },
    mobPosition: {
      type: String,
      required: false,
      default: 'center',
    },
    size: {
      type: Number,
    },
    mobSize: {
      type: Number,
    },
    weight: {
      type: [String, Number],
    },
    mobWeight: {
      type: [String, Number],
    },
  },
  computed: {
    styleObject() {
      return {
        fontWeight: this.weight,
        textAlign: this.position,
        fontSize: this.size + 'px',
      };
    },
    mobStyleObject() {
      return {
        fontWeight: this.mobWeight ? this.mobWeight : this.weight,
        textAlign: this.mobPosition,
        fontSize: this.mobSize + 'px',
      };
    },
  },
})
export default class Title extends Vue {}
